import { useState } from "react";
import { useSelector } from "react-redux";
import ListTypeCharges from './ListTypeCharges';
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function AjoutCharges() {
    const userData = useSelector(state => state.userData);
    const id = userData.id;
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();

    // 10 lignes vides par défaut
    const [charges, setCharges] = useState(
        Array.from({ length: 10 }, () => ({
            categorie: '',
            frequence: 'Ponctuelle',
            montant: '',
            designation: '',
            date: new Date().toISOString().substring(0, 10)
        }))
    );

    const handleChange = (index, field, value) => {
        const updated = [...charges];
        updated[index][field] = value;
        setCharges(updated);
    };

    const handleSubmit = async () => {
        // filtrer les lignes vides
        const filledCharges = charges.filter(c => 
            c.categorie && c.montant && c.designation
        );

        if (filledCharges.length === 0) {
            alert("Veuillez remplir au moins une ligne.");
            return;
        }

        try {
            await axios.post(`${apiUrl}new/charges_batch/${id}`, filledCharges);
            alert("Charges enregistrées !");
            navigate("/home/charges"); // adapter si route différente
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'enregistrement");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Ajouter plusieurs charges</h2>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Catégorie</th>
                            <th>Fréquence</th>
                            <th>Montant</th>
                            <th>Désignation</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {charges.map((c, index) => (
                            <tr key={index}>
                                <td>
                                    <select
                                        className="form-select"
                                        value={c.categorie}
                                        onChange={e => handleChange(index, "categorie", e.target.value)}
                                    >
                                        <option value="">-- Choisir --</option>
                                        <ListTypeCharges />
                                    </select>
                                </td>
                                <td>
                                    <select
                                        className="form-select"
                                        value={c.frequence}
                                        onChange={e => handleChange(index, "frequence", e.target.value)}
                                    >
                                        <option value="Ponctuelle">Ponctuelle</option>
                                        <option value="Perpétuelle">Perpétuelle</option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={c.montant}
                                        onChange={e => handleChange(index, "montant", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={c.designation}
                                        onChange={e => handleChange(index, "designation", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={c.date}
                                        onChange={e => handleChange(index, "date", e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="mt-3">
                <button className="btn btn-success" onClick={handleSubmit}>
                    Enregistrer
                </button>
                <button className="btn btn-secondary ms-2" onClick={() => navigate("/home/charges")}>
                    Annuler
                </button>
            </div>
        </div>
    );
}
